import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { Icon, Icons, Tooltip, Typography } from '../../../stories/atoms';
import { ColumnFlexContainer, RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme } from '../../../theme';
import { CommonStateContainer } from '../../home/common/widgetCardContent/WidgetCardContent.styles';
import { WidgetCommonState } from '../../home/common/widgetCommonState/WidgetCommonState';
import { Widget } from './StoreWidgetContent.styles';

type StoreWidgetContentProps = {
  widgetVariant: 'tall' | 'default';
  title: string;
  tooltipText: string;
  isLoading?: boolean;

  isError?: boolean;
  errorText?: string;
  errorRetryHandler?: () => void;

  isNoData?: boolean;
  noDataText?: string;

  rightContainerElements?: React.ReactNode;
  widgetContent: React.ReactNode;
  isExpanded?: boolean;
};

export const StoreWidgetContent: FC<StoreWidgetContentProps> = ({
  widgetVariant,
  title,
  tooltipText,
  isLoading,
  isError,
  errorText,
  errorRetryHandler,
  isNoData,
  rightContainerElements,
  noDataText,
  widgetContent,
  isExpanded = false,
}) => {
  const isSmallDesktop = useMediaQuery(muiTheme.breakpoints.down('desktop'));

  const showLoading = isLoading;
  const showError = !isLoading && isError;
  const showNoData = !isLoading && !isError && isNoData;
  const showContent = !isLoading && !isError && !isNoData;

  return (
    <Widget
      $isSmallDesktop={isSmallDesktop}
      $variant={widgetVariant}
      $isExpanded={isExpanded}
      data-testid="widget-wrapper"
    >
      <ColumnFlexContainer padding={[4]} height="100%">
        <RowFlexContainer alignItems="start" justifyContent="between">
          <RowFlexContainer alignItems="center">
            <Typography data-testid="title" type="button">
              {title}
            </Typography>
            <Tooltip position="bottom-start" text={<Typography color="white">{tooltipText}</Typography>}>
              <Icon data-testid="header-icon" icon={Icons.INFO} size="small" margin={[0, 0, 0, 1]} />
            </Tooltip>
          </RowFlexContainer>
          {rightContainerElements}
        </RowFlexContainer>
        {showLoading && (
          <CommonStateContainer>
            <WidgetCommonState isLoading />
          </CommonStateContainer>
        )}
        {showError && (
          <CommonStateContainer>
            <WidgetCommonState isError errorText={errorText} errorRetryHandler={errorRetryHandler} />
          </CommonStateContainer>
        )}

        {showNoData && (
          <CommonStateContainer>
            <WidgetCommonState isNoData customNoDataText={noDataText} />
          </CommonStateContainer>
        )}
        {showContent && widgetContent}
      </ColumnFlexContainer>
    </Widget>
  );
};
